export class ProducerEmail {
  public email: string;
  public effectiveDate: string;
  public endEffectiveDate: string;
}
